import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Producto } from '../models/producto.model';

@Injectable({
  providedIn: 'root'
})
export class ProductosService {

  public vista: string = 'P'; // Vista P = Productos, C = Compras
  
  // 1. Inicializamos el Subject con un array vacío de productos
  private productosSubject = new BehaviorSubject<Producto[]>([]);
  
  // 2. Exponemos el Observable para suscribirnos desde los componentes (o usar el | async pipe)
  productos$ = this.productosSubject.asObservable();

  constructor() { }

  /**
   * Reemplazar toda la lista de productos (útil al traerlos de la API)
   */
  setProductos(productos: Producto[]): void {
    this.productosSubject.next(productos);
  }

  /**
   * Obtener el valor síncrono actual del array de productos
   */
  getProductos(): Producto[] {
    return this.productosSubject.value;
  }

  /**
   * Añadir un nuevo producto al array reactivamente
   */
  addProducto(nuevoProducto: Producto): void {
    const productosActuales = this.getProductos();
    // Usamos el operador spread [...] para crear un nuevo array (inmutabilidad)
    this.productosSubject.next([nuevoProducto, ...productosActuales]);
  }

  /**
   * Actualizar un producto existente por su ID
   */
  updateProducto(id: number, cambios: Partial<Producto>): void {
    const productosActuales = this.getProductos();
    const productosActualizados = productosActuales.map(prod => {
      if (prod.pr_id === id) {
        return { ...prod, ...cambios }; // Fusiona el producto con los nuevos cambios
      }
      return prod;
    });
    this.productosSubject.next(productosActualizados);
  }

  /**
   * Eliminar un producto del array por su ID
   */
  deleteProducto(id: number): void {
    const productosActuales = this.getProductos();
    // Filtramos para dejar fuera el ID que queremos borrar
    const productosFiltrados = productosActuales.filter(prod => prod.pr_id !== id);
    this.productosSubject.next(productosFiltrados);
  }

  /**
   * Limpiar por completo la tabla de productos
   */
  vaciarProductos(): void {
    this.productosSubject.next([]);
  }
}